import { render, staticRenderFns } from "./SceneImage.vue?vue&type=template&id=dae1181c&scoped=true&"
import script from "./SceneImage.vue?vue&type=script&lang=js&"
export * from "./SceneImage.vue?vue&type=script&lang=js&"
import style0 from "./SceneImage.vue?vue&type=style&index=0&id=dae1181c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae1181c",
  null
  
)

export default component.exports